import React, { useState } from 'react';
import Modal from '../../components/ui/Modal';
import Btn from '../../components/ui/Btn';
import { Input, Select } from '../../components/ui/Input';
import { metasApi } from '../../api/rh';
import { COLORS } from '../../theme';

const TIPOS = [
  { value: 'valor_venda', label: 'Valor de Venda' },
  { value: 'valor_lucro', label: 'Valor de Lucro' }
];

export default function NovaMetaModal({ mes, ano, funcionarios, onFechar, onCriada }) {
  const [funcionarioId, setFuncionarioId] = useState('');
  const [tipo, setTipo] = useState('valor_venda');
  const [valorMeta, setValorMeta] = useState('');
  const [valorBonificacao, setValorBonificacao] = useState('');
  const [descricao, setDescricao] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const opcoesFuncionarios = [{ value: '', label: 'Meta Geral (Empresa)' }, ...funcionarios.map(f => ({ value: String(f.id), label: f.nome }))];

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    if (!valorMeta || Number(valorMeta) <= 0) { setErro('Informe o valor da meta'); return; }
    setSalvando(true);
    try {
      await metasApi.criar({
        funcionario_id: funcionarioId || null,
        mes, ano, tipo,
        valor_meta: valorMeta,
        valor_bonificacao: valorBonificacao || 0,
        descricao: descricao || null
      });
      onCriada();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal
      titulo="Nova Meta"
      onFechar={onFechar}
      largura={480}
      rodape={
        <>
          <Btn variante="ghost" onClick={onFechar}>Cancelar</Btn>
          <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
        </>
      }
    >
      <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Select label="Vendedor" options={opcoesFuncionarios} value={funcionarioId} onChange={e => setFuncionarioId(e.target.value)} />
        <Select label="Tipo de Meta" options={TIPOS} value={tipo} onChange={e => setTipo(e.target.value)} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <Input label="Valor da Meta R$" type="number" step="0.01" value={valorMeta} onChange={e => setValorMeta(e.target.value)} />
          <Input label="Bonificação R$" type="number" step="0.01" value={valorBonificacao} onChange={e => setValorBonificacao(e.target.value)} />
        </div>
        <Input label="Descrição (opcional)" value={descricao} onChange={e => setDescricao(e.target.value)} placeholder="Ex: Meta de vendas do mês" />
        <p style={{ fontSize: 11, color: COLORS.textLight, margin: 0 }}>
          Meta de {mes}/{ano}. {!funcionarioId && 'Meta geral soma as vendas de todos os vendedores — sem bonificação automática na folha, já que não há um único responsável.'}
        </p>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
      </form>
    </Modal>
  );
}
